import 'initializers/sentry'

import '@rails/request.js'
import '@hotwired/turbo-rails'

import 'initializers/stimulus'
import 'initializers/jquery'
import 'initializers/datatables'
import 'initializers/flatpickr'
import 'initializers/see_password'
import 'initializers/modal'

import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
window.bootstrap = bootstrap

if (typeof Element !== 'undefined' && !Element.prototype.checkVisibility) {
  Element.prototype.checkVisibility = function() {
    if (!this.ownerDocument || !this.ownerDocument.defaultView) {
      return false
    }
    
    const style = this.ownerDocument.defaultView.getComputedStyle(this)
    
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false
    }
    
    return !!(this.offsetWidth || this.offsetHeight || this.getClientRects().length)
  }
}
